export default function Cancelled() {
    return (
        <section className="mt-24">
            <h1 className="text-5xl">
                Payment Cancelled
            </h1>
        </section>
    )
}